import PageDetail from "../abstract/PageDetail.js";

export default class PageLookupCustom extends PageDetail {
	constructor() {
		super();
	}

	init($data) {
		super.init($data);
		// custm
	}

	filterOption(r) {

		return super.filterOption(r);
	}

}
